import maplibregl from 'maplibre-gl'
import {
  distance as turfDistance,
  destination as turfDestination,
  circle as turfCircle,
} from '@turf/turf'

export function haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
  return turfDistance([lng1, lat1], [lng2, lat2], { units: 'meters' })
}

export function calculateDestinationPoint(
  start: maplibregl.LngLat,
  distance: number,
  bearing: number
): maplibregl.LngLat {
  const dest = turfDestination([start.lng, start.lat], distance, bearing, { units: 'meters' })
  const [lng, lat] = dest.geometry.coordinates
  return new maplibregl.LngLat(lng, lat)
}

export function circleToGeoJSONCoords(
  center: [number, number],
  radius: number,
  steps = 64
): number[][] {
  if (radius === 0) {
    return Array.from({ length: steps + 1 }, () => [center[0], center[1]])
  }
  return turfCircle(center, radius, { steps, units: 'meters' }).geometry.coordinates[0]
}

export function screenToLngLat(
  map: maplibregl.Map,
  clientX: number,
  clientY: number
): maplibregl.LngLat {
  const rect = map.getContainer().getBoundingClientRect()
  return map.unproject([clientX - rect.left, clientY - rect.top])
}

export function touchToLngLat(map: maplibregl.Map, touch: Touch): maplibregl.LngLat {
  return screenToLngLat(map, touch.clientX, touch.clientY)
}
